import { render, staticRenderFns } from "./modal-card-resumo-propostas.vue?vue&type=template&id=3147a29a"
import script from "./modal-card-resumo-propostas.vue?vue&type=script&lang=js"
export * from "./modal-card-resumo-propostas.vue?vue&type=script&lang=js"
import style0 from "./modal-card-resumo-propostas.vue?vue&type=style&index=0&id=3147a29a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports